// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"36":"af98b889","44":"d2814782","74":"de13179d","155":"38c37216","545":"0c4791f6"}[chunkId] + ".chunk.js";
};